/* assets/mr-auth-loader.js
   Maison Roziere — Global Auth Loader (Login + Register)
   - Shows loader on EVERY submit attempt (including retries)
   - Disables submit to prevent double actions
   - Resets cleanly on error page loads + bfcache restore
*/

(function () {
  if (window.__MR_AuthLoader_Bound) return;
  window.__MR_AuthLoader_Bound = true;

  var FAILSAFE_MS = 15000;

  function isLoginForm(form) {
    return !!(form && (form.id === 'customer_login' || form.querySelector('input[name="form_type"][value="customer_login"]')));
  }

  function isRegisterForm(form) {
    return !!(form && form.querySelector('input[name="form_type"][value="create_customer"]'));
  }

  function getSubmitBtn(form) {
    if (!form) return null;
    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  function setSubmitEnabled(form, enabled) {
    var btn = getSubmitBtn(form);
    if (!btn) return;
    btn.disabled = !enabled;
    if (enabled) btn.removeAttribute('aria-disabled');
    else btn.setAttribute('aria-disabled', 'true');
  }

  function showLoader(form) {
    if (!window.MRPageLoader) return;

    var labelAttr = form && form.getAttribute('data-mr-loader-label');
    var textAttr  = form && form.getAttribute('data-mr-loader-text');

    var label = labelAttr || 'Client Services Note';

    // ✅ Required defaults by form type:
    // - Login    => "Preparing your account…"
    // - Register => "Creating your account…"
    // - Other    => "Loading…"
    var defaultText = 'Loading…';
    if (isLoginForm(form)) defaultText = 'Preparing your account…';
    else if (isRegisterForm(form)) defaultText = 'Creating your account…';

    // If a form explicitly sets data-mr-loader-text, respect it.
    // Otherwise use our required defaults above.
    var text = textAttr || defaultText;

    window.MRPageLoader.show({ label: label, text: text });
  }

  function hideLoader() {
    try { window.MRPageLoader && window.MRPageLoader.hide(); } catch (e) {}
  }

  function hasServerErrors() {
    return !!document.querySelector('.form-errors, .error-message, .errors, .errors ul, .errors li');
  }

  function resetAllAuthForms() {
    hideLoader();

    // Re-enable buttons on both known form types (if present)
    var loginForm = document.getElementById('customer_login') || document.querySelector('form[action*="/account/login"]');
    if (loginForm) setSubmitEnabled(loginForm, true);

    var registerMarker = document.querySelector('form input[name="form_type"][value="create_customer"]');
    var registerForm = registerMarker ? registerMarker.closest('form') : null;
    if (registerForm) setSubmitEnabled(registerForm, true);

    // Clear any previous failsafes
    try { window.clearTimeout(window.__MR_AuthLoader_Timer); } catch (e) {}
    window.__MR_AuthLoader_Timer = null;
  }

  // Clean reset on load + bfcache restore
  document.addEventListener('DOMContentLoaded', resetAllAuthForms);
  window.addEventListener('pageshow', resetAllAuthForms);

  // If Shopify returns errors, ensure we never remain disabled/hidden
  document.addEventListener('DOMContentLoaded', function () {
    if (hasServerErrors()) resetAllAuthForms();
  });

  // Global submit capture — this is the key
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !(form instanceof HTMLFormElement)) return;

    var isAuth = isLoginForm(form) || isRegisterForm(form);
    if (!isAuth) return;

    // Respect native required-field prompts (don’t mask)
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      hideLoader();
      setSubmitEnabled(form, true);
      return;
    }

    // Always show loader on every attempt
    showLoader(form);

    // Disable immediately to prevent double submit
    setSubmitEnabled(form, false);

    // Failsafe: never trap the customer
    try { window.clearTimeout(window.__MR_AuthLoader_Timer); } catch (err) {}
    window.__MR_AuthLoader_Timer = window.setTimeout(function () {
      hideLoader();
      setSubmitEnabled(form, true);
    }, FAILSAFE_MS);
  }, true);

  // If user edits after an error, make sure submit is enabled (luxury “never stuck”)
  document.addEventListener('input', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form');
    if (!form) return;
    if (!isLoginForm(form) && !isRegisterForm(form)) return;
    setSubmitEnabled(form, true);
  }, true);
})();
